import { Component, OnInit, ViewChild } from '@angular/core';
import { Nav } from "ionic-angular";

import { ContextMenu } from '../../models/context-menu.model';
import { Link } from "../../models/link.model";
import { AuthLocalService } from '../../core/util/auth-local.service';
import { LoginService } from '../../core/data/login.service';
import { MenuService } from "../../core/util/menu.service";
import {AppInfosService} from "../../core/data/app-infos.service";

@Component({
  selector: 'menu-list',
  templateUrl: 'menu-list.html',
  inputs: ['nav']
})
export class MenuListComponent implements OnInit {
  fixedLinks: Link[];
  @ViewChild(Nav) nav: Nav;
  private contextMenu: ContextMenu;
  front_version: string;
  back_version: string;

  constructor(public authLocalService: AuthLocalService,
              private loginService: LoginService,
              private menuService: MenuService,
              private infosAppService: AppInfosService) {

    this.
      front_version = this.infosAppService.getFrontVersion();
    this.fixedLinks = [
      { name: 'Mesures', icon: 'ios-list-box-outline', route: 'MeasureListPage' },
      { name: 'Analyses', icon: 'analytics', route: 'PkWearForecastPage' },
      { name: 'Priorités', icon: 'alert', route: 'ReplacementPrioritiesPage', params: { prioritiesType: 'replacement' } },
      { name: 'Observations', icon: 'eye', route: 'ObservationsPage', params: { observationState: 'NEW' } },
      { name: 'Paramétrage', icon: 'options', route: 'ObservationTypesSettingsPage' },
      { name: 'Campagnes', icon: 'calendar', route: 'CampaignInProgressPage' }
    ];
  }

  ngOnInit() {
    this.menuService.contextMenuUpdated$.subscribe((contextMenu: ContextMenu) => this.contextMenu = contextMenu);
    this.getBackAppVersion();
  }

  isActivePage(link: Link): boolean {
    return this.getActivePageName() === link.route && JSON.stringify(this.getActivePageNavParams()) == JSON.stringify(link.params);
  }

  logout() {
    this.loginService.logout().subscribe(
      () => this.nav.setRoot('LoginPage')
    );
  }

  navigateToPage(page: string, params: string) {
    this.nav.setRoot(page, params);
  }

  private getActivePageName() {
    return this.nav.getActive().name;
  }

  private getActivePageNavParams() {
    return Object.keys(this.nav.getActive().getNavParams().data).length ? this.nav.getActive().getNavParams().data : undefined;
  }

  getBackAppVersion() {
    this.infosAppService.getAppVersion().subscribe(data => {
      this.back_version = data.back_version;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-list/menu-list.ts